/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PerformanceIndicatorDataFilter', 'model/PerformanceIndicatorYearData', 'model/CorporateStructureLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/PerformanceIndicatorDataFilter'), require('../model/PerformanceIndicatorYearData'), require('../model/CorporateStructureLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorYearDataApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PerformanceIndicatorDataFilter, root.ForStractionServiceApi.PerformanceIndicatorYearData, root.ForStractionServiceApi.CorporateStructureLink);
  }
}(this, function(ApiClient, PerformanceIndicatorDataFilter, PerformanceIndicatorYearData, CorporateStructureLink) {
  'use strict';

  /**
   * PerformanceIndicatorYearData service.
   * @module api/PerformanceIndicatorYearDataApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new PerformanceIndicatorYearDataApi. 
   * @alias module:api/PerformanceIndicatorYearDataApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the performanceIndicatorYearDataClearPut operation.
     * @callback module:api/PerformanceIndicatorYearDataApi~performanceIndicatorYearDataClearPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * clear
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorDataFilter>} body 
     * @param {module:api/PerformanceIndicatorYearDataApi~performanceIndicatorYearDataClearPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorYearDataClearPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorYearDataClearPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorYearDataClearPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorYearData/clear', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorYearDataMergeAllPut operation.
     * @callback module:api/PerformanceIndicatorYearDataApi~performanceIndicatorYearDataMergeAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorYearData>} body 
     * @param {Boolean} rollOverLevels 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.aggregationLevelID 
     * @param {module:api/PerformanceIndicatorYearDataApi~performanceIndicatorYearDataMergeAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.performanceIndicatorYearDataMergeAllPut = function(_4SAPIAppID, body, rollOverLevels, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorYearDataMergeAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorYearDataMergeAllPut";
      }

      // verify the required parameter 'rollOverLevels' is set
      if (rollOverLevels == undefined || rollOverLevels == null) {
        throw "Missing the required parameter 'rollOverLevels' when calling performanceIndicatorYearDataMergeAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'rollOverLevels': rollOverLevels,
        'aggregationLevelID': opts['aggregationLevelID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/PerformanceIndicatorYearData/mergeAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorYearDataMergeTargetActualValuePut operation.
     * @callback module:api/PerformanceIndicatorYearDataApi~performanceIndicatorYearDataMergeTargetActualValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetActualValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} indicatorID 
     * @param {Number} actual 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorYearDataApi~performanceIndicatorYearDataMergeTargetActualValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorYearDataMergeTargetActualValuePut = function(_4SAPIAppID, body, year, indicatorID, actual, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorYearDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorYearDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorYearDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorYearDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'actual' is set
      if (actual == undefined || actual == null) {
        throw "Missing the required parameter 'actual' when calling performanceIndicatorYearDataMergeTargetActualValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'indicatorID': indicatorID,
        'actual': actual,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorYearData/mergeTargetActualValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorYearDataMergeTargetBudgetValuePut operation.
     * @callback module:api/PerformanceIndicatorYearDataApi~performanceIndicatorYearDataMergeTargetBudgetValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetBudgetValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} indicatorID 
     * @param {Number} budget 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorYearDataApi~performanceIndicatorYearDataMergeTargetBudgetValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorYearDataMergeTargetBudgetValuePut = function(_4SAPIAppID, body, year, indicatorID, budget, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorYearDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorYearDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorYearDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorYearDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'budget' is set
      if (budget == undefined || budget == null) {
        throw "Missing the required parameter 'budget' when calling performanceIndicatorYearDataMergeTargetBudgetValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'indicatorID': indicatorID,
        'budget': budget,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorYearData/mergeTargetBudgetValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorYearDataMergeTargetForecastValuePut operation.
     * @callback module:api/PerformanceIndicatorYearDataApi~performanceIndicatorYearDataMergeTargetForecastValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetForecastValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} indicatorID 
     * @param {Number} forecast 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorYearDataApi~performanceIndicatorYearDataMergeTargetForecastValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorYearDataMergeTargetForecastValuePut = function(_4SAPIAppID, body, year, indicatorID, forecast, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorYearDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorYearDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorYearDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorYearDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'forecast' is set
      if (forecast == undefined || forecast == null) {
        throw "Missing the required parameter 'forecast' when calling performanceIndicatorYearDataMergeTargetForecastValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'indicatorID': indicatorID,
        'forecast': forecast,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorYearData/mergeTargetForecastValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorYearDataMergeTargetGoalValuePut operation.
     * @callback module:api/PerformanceIndicatorYearDataApi~performanceIndicatorYearDataMergeTargetGoalValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetGoalValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} indicatorID 
     * @param {Number} goal 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorYearDataApi~performanceIndicatorYearDataMergeTargetGoalValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorYearDataMergeTargetGoalValuePut = function(_4SAPIAppID, body, year, indicatorID, goal, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorYearDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorYearDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorYearDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorYearDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'goal' is set
      if (goal == undefined || goal == null) {
        throw "Missing the required parameter 'goal' when calling performanceIndicatorYearDataMergeTargetGoalValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'indicatorID': indicatorID,
        'goal': goal,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorYearData/mergeTargetGoalValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorYearDataMergeTargetValuePut operation.
     * @callback module:api/PerformanceIndicatorYearDataApi~performanceIndicatorYearDataMergeTargetValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} indicatorID 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.actual 
     * @param {Number} opts.goal 
     * @param {Number} opts.budget 
     * @param {Number} opts.forecast 
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorYearDataApi~performanceIndicatorYearDataMergeTargetValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorYearDataMergeTargetValuePut = function(_4SAPIAppID, body, year, indicatorID, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorYearDataMergeTargetValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorYearDataMergeTargetValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorYearDataMergeTargetValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorYearDataMergeTargetValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'indicatorID': indicatorID,
        'actual': opts['actual'],
        'goal': opts['goal'],
        'budget': opts['budget'],
        'forecast': opts['forecast'],
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorYearData/mergeTargetValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorYearDataSearchPut operation.
     * @callback module:api/PerformanceIndicatorYearDataApi~performanceIndicatorYearDataSearchPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PerformanceIndicatorYearData>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * search
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorYearData>} body 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.startDate 
     * @param {Date} opts.endDate 
     * @param {module:api/PerformanceIndicatorYearDataApi~performanceIndicatorYearDataSearchPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PerformanceIndicatorYearData>}
     */
    this.performanceIndicatorYearDataSearchPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorYearDataSearchPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorYearDataSearchPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startDate': opts['startDate'],
        'endDate': opts['endDate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PerformanceIndicatorYearData];

      return this.apiClient.callApi(
        '/PerformanceIndicatorYearData/search', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
